import { RootState } from "@/reducers/store"
import type { RoutingProvider } from "@/reducers/serviceConfigSlice"

/** Default routing provider assumed when the service config has not yet been fetched. */
export const DEFAULT_ROUTING_PROVIDER: RoutingProvider = "here"

export const selectRoutingProvider = (state: RootState): RoutingProvider =>
  state.serviceConfig?.gps?.routingProvider ?? DEFAULT_ROUTING_PROVIDER

export const selectIsPtvRouting = (state: RootState): boolean =>
  selectRoutingProvider(state) === "ptv"

export const selectIsHereRouting = (state: RootState): boolean =>
  selectRoutingProvider(state) === "here"
